"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _validations.required;
  }
});
Object.defineProperty(exports, "minlength", {
  enumerable: true,
  get: function get() {
    return _validations.minlength;
  }
});
Object.defineProperty(exports, "maxlength", {
  enumerable: true,
  get: function get() {
    return _validations.maxlength;
  }
});
Object.defineProperty(exports, "pattern", {
  enumerable: true,
  get: function get() {
    return _validations.pattern;
  }
});
Object.defineProperty(exports, "dependent", {
  enumerable: true,
  get: function get() {
    return _validations.dependent;
  }
});
Object.defineProperty(exports, "checkErrors", {
  enumerable: true,
  get: function get() {
    return _validations.checkErrors;
  }
});
Object.defineProperty(exports, "composeValidators", {
  enumerable: true,
  get: function get() {
    return _validations.composeValidators;
  }
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFinalForm = require("react-final-form");

var _finalFormFocus = _interopRequireDefault(require("final-form-focus"));

var _field = _interopRequireDefault(require("./field"));

var _actions = _interopRequireDefault(require("./actions"));

var _components = require("./field/components");

var _validations = require("./validations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* 
* name: getRules
* Description: this function will be used to get the validate function required by React Final Form
* @param {Object}: Validation rules as nameOfField: [array of validation]
*                  firstName: [
*                     {
*                       required: true,
*                       msg: 'Required'
*                     }
*                   ]
* @return {function}: Validate function 
*/
var getRules = function getRules(rulesObject) {
  var validate = function validate(allValues) {
    var errors = {}; //* iterate over each entry of rules defined in props.rulesToValidate

    for (var fieldName in rulesObject) {
      var errorVal = (0, _validations.checkErrors)(fieldName, rulesObject[fieldName], allValues);

      if (errorVal) {
        errors[fieldName] = errorVal;
      }
    }

    return errors;
  };

  return validate;
};

var focusOnError = (0, _finalFormFocus["default"])();

var Form = function Form(props) {
  var validateRules = getRules(props.rulesToValidate);
  return _react["default"].createElement(_reactFinalForm.Form, _extends({}, props, {
    validate: validateRules,
    decorators: [focusOnError]
  }), function (_ref) {
    var handleSubmit = _ref.handleSubmit,
        _ref$form = _ref.form,
        reset = _ref$form.reset,
        values = _ref$form.values,
        submitting = _ref.submitting,
        pristine = _ref.pristine;
    return _react["default"].createElement("form", {
      onSubmit: handleSubmit,
      autoComplete: props.autoComplete
    }, _react["default"].Children.map(props.children, function (child) {
      return _react["default"].cloneElement(child, {
        reset: reset,
        submitting: submitting,
        pristine: pristine,
        values: values,
        handleSubmit: handleSubmit
      });
    }));
  });
};

Form.Field = function (props) {
  return _react["default"].createElement(_field["default"], props);
};

Form.TextInput = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.TextInputAdapter
  }));
};

Form.TextArea = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.TextAreaAdaper
  }));
};

Form.Checkbox = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.CheckboxAdapter
  }));
};

Form.Radios = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.RadiosAdapter
  }));
};

Form.Switch = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.SwitchAdapter
  }));
};

Form.ActionInput = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.ActionInputAdapter
  }));
};

Form.Dropdown = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.DropdownAdapter
  }));
};

Form.SearchableInput = function (props) {
  return _react["default"].createElement(_field["default"], _extends({}, props, {
    component: _components.SearchableInputAdapter
  }));
};

Form.Actions = _actions["default"];
Form.propTypes = {};
Form.defaultProps = {};
var _default = Form;
exports["default"] = _default;